import { EndpointReponseProps } from "../types";

const rawBase = process.env.REACT_APP_BASE_URL;
const rootBase =
  rawBase && rawBase.trim().length ? rawBase.trim() : "http://localhost:8080";

const baseURL = `${rootBase}/api`;

export const Endpoints = {
  GetCheckServerHealth: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/health`,
      method: "GET",
    };
  },
  JoinWaitlist: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/access/request`,
      method: "POST",
    };
  },
  GetAnnouncements: (params?: {
    activeOnly?: boolean;
    page?: number;
    limit?: number;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.activeOnly === undefined || params.activeOnly) {
      q.set("activeOnly", "true");
    } else {
      q.set("activeOnly", "false");
    }

    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));

    const qs = q.toString();
    return {
      route: `${baseURL}/announcements${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  RequestAccountDeletion: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/delete-request`,
      method: "POST",
    };
  },
  VerifyAccountDeletion: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/delete-verify`,
      method: "POST",
    };
  },
};
